import React, { useEffect, useState } from "react";
import styles from "./RechargeResultContent.module.css";
import { createOrder, pgiAutoLogin, recurringPaySetup } from "../../Services/pgi";
import { connect, useDispatch } from "react-redux";
import { url } from "../../Values/constants";
import axiosHandler from "../../Services/axiosHandler";
import { useHistory } from "react-router";
import { readproPackagePurchaseViaPGI } from "../../Services/pgi";
interface RechargeResultContentProps {
  props?: any;
  setRechargeResult: (open: boolean) => void;
  result?: any;
  price?: any;
  unit?: any;
  Id?: any;
  validityDays?: any;
  name?: any;
  date?: any;
  orignalPrice?: any;
  user?: any;
  validTill?: any;
  planName?: any;
  packageId?:any;
  topUp?:any,
  uotPayStatus?:any,
  recurringPayStatus?:any
  tag?:any
  responseGst?:any
  isPgiFlowAlreadyPunched?: string
}

const RechargeResultContent: React.FC<RechargeResultContentProps> = ({
  setRechargeResult,
  result,
  price,
  unit,
  Id,
  validityDays,
  name,
  date,
  orignalPrice,
  user,
  validTill,
  planName,
  packageId,
  topUp,
  uotPayStatus,
  recurringPayStatus,
  tag,
  responseGst,
  isPgiFlowAlreadyPunched
}) => {
  const [isRechargeFailed, setIsRechargeFailed] = useState<boolean>(result);
  const section = JSON.parse(localStorage.getItem("gstData") || "{}");
  const [token, setToken] = useState<any>();
  const [bricksLogin, setBricksLogin] = useState<boolean>(false);
  const history = useHistory();
  const dispatcher = useDispatch();
// console.log("section",section)
    const closeHandler = () => {
      setRechargeResult(false);
      document.body.classList.remove("no-overflow");
      window.location.href = "/whatsappRechargePlans"; // Full reload
    };

  const tryAgainHandler = () => {
    readproPackagePurchaseViaPGI(user.user_super_oid, packageId, dispatcher, false, recurringPayStatus, responseGst);
  };

  return (
    <div className={styles.AtmbilpayContent}>
      <iframe
        src={token}
        title="HiddenIframe"
        style={{ display: "none" }}
        onLoad={() => setBricksLogin(true)}
      />
      <div
        className={`${styles.AtmbilpayImageBox} ${
          isRechargeFailed ? styles.Failed : ""
        }`}
      ></div>
      <div
        className={`${styles.AtmbilpayTitle} ${
          isRechargeFailed ? styles.Failed : ""
        }`}
      >
        {recurringPayStatus === "Y"
          ? isRechargeFailed
          ? "Payment Failed"
          : "Payment Successful"
          : isRechargeFailed
          ? "Payment Failed"
          : "Payment Successful"
        }
      </div>
      <div className={styles.AtmbilpayBillCard}>
        {isRechargeFailed && (
          <div className={styles.StatusInfo}>
            <span className={styles.TextBold}>
              Any debited amount will be refunded shortly.
            </span>
            <br />
            Please try again or contact support if the issue persists
          </div>
        )}
        <div className={styles.Transactions}>
          <div className={styles.TransactionsRow}>
            <span className={styles.TransactionsLabel}>Transaction ID</span>
            <span
              className={`${styles.TransactionsData} ${styles.TransactionsId}`}
            >
              {Id ? Id : "---"}
            </span>
          </div>
          <div className={styles.TransactionsRow}>
            <span className={styles.TransactionsLabel}>Date & Time</span>
            <span className={styles.TransactionsData}>
              {date ? date : ""}
            </span>
          </div>
          <div className={styles.TransactionsRow}>
            <span className={styles.TransactionsLabel}>User</span>
            <span
              className={`${styles.TransactionsData} ${styles.User}`}
            >
              {name ? name : ""}
            </span>
          </div>
        </div>
        <div className={styles.Plan}>Plan</div>
        <div className={styles.PlanCardInfo}>
          <div className={styles.PlanCardInfoi}>
            <div className={styles.PlanCardLabel}>Price</div>
            <div className={styles.PlanCardData}>
              <span className={styles.Rupees}>&#8377;</span> {orignalPrice ? orignalPrice : "0"}
            </div>
          </div>
          <div className={styles.PlanCardInfoi}>
            <div className={styles.PlanCardLabel}>Validity</div>
            <div className={styles.PlanCardData}>
              {validityDays ? validityDays.replace(/(\d+)([A-Za-z]+)/, "$1 $2") : "0"}
            </div>
          </div>
          <div className={styles.PlanCardInfoi}>
            <div className={styles.PlanCardLabel}>Balance</div>
            <div className={styles.PlanCardData}>
              {unit ? unit : "0"} Credits
            </div>
          </div>
        </div>
      </div>
      <div className={styles.AtmbilpayActns}>
        <span
          className={`${styles.AtmbilpayCtaOutlined} ${
            isRechargeFailed ? "CtaOutlined" : "CtaFilled"
          }`}
          onClick={closeHandler}
        >
          Close
        </span>
        {isRechargeFailed && (
          <span
            className={`${styles.AtmbilpayCtaOutlined} CtaFilled`}
            onClick={tryAgainHandler}
          >
            Try Again
          </span>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
  };
};

export default connect(mapStateToProps)(RechargeResultContent);
